:host {
  display: block;
}

cwru-main-container {
  display: block;
  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;
  text-align: inherit;
  max-width: var(--max);
  padding-left: var(--gutters);
  padding-right: var(--gutters);
  padding-bottom: var(--s1);
  padding-top: 1rem !important;
  background: var(--color-white);
  font-size: 20px;
  line-height: 1.42857;
  font-family: var(--font-plain);
}

cwru-main-container .cwru-main-container.center {
  text-align: center;
}

cwru-main-container .cwru-main-container.intrinsic {
  display: flex;
  flex-direction: column;
  align-items: center;
}

cwru-main-container .main-container h1,
cwru-main-container .main-container h2,
cwru-main-container .main-container h3,
cwru-main-container .main-container h4,
cwru-main-container .main-container h5,
cwru-main-container .main-container h6 {
  color: var(--color-cwru-blue);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-plain);
  padding: 0 0 0.3em;
  margin: 0;
  line-height: 1.1;
}

cwru-main-container .main-container h2 {
  font-size: 35px;
}

cwru-main-container h1 {
  color: var(--color-black);
  font-size: 2rem;
  font-weight: 900;
}

cwru-main-container .h2,
cwru-main-container h2 {
  font-size: 1.5rem;
  margin-top: 20px;
}

cwru-main-container .h3,
cwru-main-container h3 {
  color: var(--color-black);
  font-size: 1.35rem;
}

cwru-main-container h4 {
  font-size: 1.25rem;
}

cwru-main-container h5 {
  font-size: 1.2rem;
}

cwru-main-container h6 {
  font-size: 1rem;
}
cwru-main-container form {
  margin: 1rem 0;
}
cwru-main-container #link_change_view {
  display: block;
}
cwru-main-container .form-question {
  box-sizing: border-box;
  margin: 0 0 1em 0;
  padding: 0;
  position: relative;
}
cwru-main-container a {
  color: var(--color-link-blue);
}
cwru-main-container a:hover {
  color: var(--color-cwru-blue) !important;
  text-decoration: underline !important;
}
cwru-main-container .form-label {
  display: block;
  padding-bottom: 3px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-dark-gray);
  cursor: pointer;
  margin: 0 0 0.1875em 0;
  padding-right: 4px;
  max-width: 100%;
}
cwru-main-container form input[type='text'],
cwru-main-container form select {
  box-sizing: border-box;
  max-width: 100%;
  vertical-align: middle;
}
cwru-main-container div.form-response input[type='text'],
cwru-main-container div.form-response select,
cwru-main-container div.form-response textarea,
cwru-main-container input[type='text'],
cwru-main-container select,
cwru-main-container textarea {
  border: 1px solid var(--color-light-gray);
  border-radius: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.75);
  display: block;
  margin: 0;
  height: 48px;
  width: 100%;
  transition: box-shadow 0.45s, border-color 0.45s ease-in-out;
  padding: 6px 10px;
  font-size: 18px;
  background: var(--color-white);
}
cwru-main-container input[type='text'],
cwru-main-container select,
cwru-main-container textarea {
  width: auto;
}
cwru-main-container .form-response .auto-width {
  width: auto !important;
}
cwru-main-container .form-response input:focus,
cwru-main-container .form-response select:focus,
cwru-main-container .form-response textarea:focus,
cwru-main-container input:focus,
cwru-main-container select:focus,
cwru-main-container textarea:focus {
  border-color: #66afe9 !important;
  outline: 0 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6) !important;
}
cwru-main-container p {
  margin: 1rem 0;
}
cwru-main-container .horizontal-form .form-question {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}
cwru-main-container .horizontal-form .form-label {
  margin-right: 1.5rem;
}
cwru-main-container .horizontal-form div.form-response input[type='text'] {
  margin-bottom: 0;
  /* width: auto; */
}
cwru-main-container .form-question-vertical {
  box-sizing: border-box;
  margin: 0 0 1em 0;
  padding: 0;
  position: relative;
}
cwru-main-container form input[type='submit'],
cwru-main-container form input[type='reset'] {
  padding: 20px !important;
  font-weight: bold;
  line-height: 12px;
  border: none;
  background: var(--color-link-blue);
  color: var(--color-white);
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: inherit;
  margin: 0;
}
cwru-main-container form input[type='submit']:hover {
  background: var(--color-cwru-blue);
}
cwru-main-container form input[type='reset'] {
  background: var(--color-light-gray);
  color: var(--color-dark-gray);
}
cwru-main-container form input[type='reset']:hover {
  background: var(--color-cwru-blue);
  color: var(--color-white);
}
cwru-main-container .form-question.outer-label-horizontal .form-label {
  display: inline-flex;
  margin-top: 1rem;
  align-items: center;
}
cwru-main-container .form-question.outer-label-horizontal .form-response {
  margin-left: 1rem;
}

cwru-main-container table {
  margin-bottom: 0;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid var(--color-white);
}
cwru-main-container table th {
  font-weight: 600;
  border: 1px solid var(--color-white);
  text-align: left;
  color: var(--color-off-white);
  background-color: var(--color-cwru-blue);
  padding: 15px;
}
cwru-main-container table tbody {
  border: 1px solid var(--color-off-white);
}
cwru-main-container table td {
  border: 1px solid var(--color-white);
  outline: none;
  padding: 15px;
  width: unset;
  vertical-align: top;
}
cwru-main-container table tbody tr:nth-child(odd) {
  background-color: var(--color-lighter-gray);
  border-top: 1px solid var(--color-white);
  border-bottom: 1px solid var(--color-off-white);
}
cwru-main-container table tbody tr:nth-child(even) {
  background-color: var(--color-off-white);
  border-top: 1px solid var(--color-white);
  border-bottom: 1px solid var(--color-off-white);
}

cwru-main-container .results {
  width: 100%;
  display: block;
  padding: 0.5rem 1rem;
  background: var(--color-blue-green);
  border: none;
  margin: 1rem 0;
  color: var(--color-white);
  font-weight: var(--font-weight-bold);
}
cwru-main-container .results.warning {
  background: var(--color-yellow);
  color: var(--color-black);
}
cwru-main-container .results.error {
  background: var(--color-orange);
}
cwru-main-container .results a {
  text-decoration: underline !important;
  color: var(--color-white) !important;
}
cwru-main-container .results a:hover {
  text-decoration: none !important;
  color: var(--color-white) !important;
}
cwru-main-container .warning a {
  color: var(--color-black) !important;
}
cwru-main-container .warning a:hover {
  color: var(--color-black) !important;
}
